export const environment = {
  production: true,
  baseUrl: 'https://api-client.beautyapp.ge/',
  // baseUrl: 'http://localhost:5500/',
  socketUrl: 'https://api-client.beautyapp.ge/',
  bookinghubAPI: 'https://api.bookinghub.ge/',
  bookinghubUrl: 'https://bookinghub.ge',
  firebaseConfig: {
    apiKey: 'AIzaSyCtZWnOCt5wI8rP7ome5aFSrROc8c_Tteo',
    authDomain: 'beautyapp-by-webapp.firebaseapp.com',
    projectId: 'beautyapp-by-webapp',
    storageBucket: 'beautyapp-by-webapp.appspot.com',
    messagingSenderId: '752261931197',
    appId: '1:752261931197:web:ad528b1ac04d14982817d4',
    measurementId: 'G-NZ9Y0EEYBV',
  },
  vapidKey:
    'BMmRnno96LxZ1sNYzao2jKyeHrZ8brsSx2iLr4-DMVtfL5xH4CW0ef7cnchLgOpkFzOkPOLhWWA9BOmeQ-d_ZW0',
  version: '5.12.3',
  serviceWorker: true,
};
